import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Contact", to: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Top phone bar */}
      <div className="bg-accent text-white text-sm py-2 px-4 text-center font-medium tracking-wide">
        <a
          href="tel:01156478686"
          className="inline-flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-fill text-sm" />
          </span>
          Call us: 01156 - 478686
        </a>
      </div>

      {/* Main nav */}
      <div
        className={`transition-all duration-300 ${
          scrolled || !isHome
            ? "bg-white shadow-sm border-b border-zinc-100"
            : "bg-transparent"
        }`}
      >
        <nav className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <h1>
              <img
                src="https://public.readdy.ai/ai/img_res/7a27f79f-61a9-4968-a678-e038698c6bd9.png"
                alt="PixelCraft Agency - Small Business Websites"
                className="h-8 md:h-10 w-auto object-contain"
              />
            </h1>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => {
              const active = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    scrolled || !isHome
                      ? active
                        ? "text-accent"
                        : "text-zinc-700 hover:text-accent"
                      : active
                      ? "text-orange-400"
                      : "text-white/90 hover:text-white"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/contact"
              className="whitespace-nowrap bg-accent hover:bg-accent-dark text-white text-sm font-bold px-5 py-2.5 rounded-lg transition-all duration-200 cursor-pointer"
            >
              £149 — Get Started
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? "text-zinc-800" : "text-white"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`} />
          </button>
        </nav>

        {/* Mobile menu */}
        <div
          className={`md:hidden bg-white border-t border-zinc-100 overflow-hidden transition-all duration-300 ${
            mobileOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="flex flex-col px-4 py-4 gap-1">
            {/* Phone number in mobile menu */}
            <a
              href="tel:01156478686"
              className="flex items-center gap-2 text-accent font-semibold px-2 py-3 border-b border-zinc-100 cursor-pointer text-sm whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm" />
              </span>
              01156 - 478686
            </a>
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-zinc-700 hover:text-accent font-medium px-2 py-3 border-b border-zinc-50 last:border-0 cursor-pointer text-sm"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-3 bg-accent hover:bg-accent-dark text-white text-sm font-bold px-5 py-3 rounded-lg text-center transition-all cursor-pointer whitespace-nowrap"
            >
              £149 — Get Started
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
